package com.xtream.data_kmp

import androidx.room3.Entity
import androidx.room3.PrimaryKey





 open class Favorite{
    @PrimaryKey
    var streamId: Int=0
    var sortOrder: Long=0L
}
const val liveFavoritesTable="liveFavoritesTable"
@Entity(tableName = liveFavoritesTable )
 class FavoriteLiveStreamEntity :Favorite()

const val vodsFavoritesTable="vodFavoritesTable"
@Entity(tableName = vodsFavoritesTable )
 class FavoriteVodStreamEntity :Favorite()


const val seriesFavoritesTable="seriesFavoritesTable"
@Entity(tableName = seriesFavoritesTable )
class FavoriteSeriesStreamEntity:Favorite()
